/*
 * Poyter: custom "Buy Now" button for the accessories upsell.
 * Adds the selected variant to the cart via the AJAX Cart API and then
 * redirects the customer to the accessories page.
 * Markup is rendered by snippets/accessories-buy-now.liquid.
 */
(function () {
  'use strict';

  var READY_ATTR = 'data-poyter-buy-now-ready';
  var DEFAULT_ERROR = 'Sorry, this item could not be added to your cart. Please try again.';

  function setLoading(button, isLoading) {
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function showError(form, message) {
    var container = form.querySelector('[data-cart-errors-container]');
    if (container) {
      container.textContent = message;
      return;
    }
    window.alert(message);
  }

  function clearError(form) {
    var container = form.querySelector('[data-cart-errors-container]');
    if (container) {
      container.textContent = '';
    }
  }

  function isVariantUnavailable(form) {
    var addButton = form.querySelector('[data-add-to-cart]');
    return Boolean(addButton && addButton.disabled);
  }

  function handleClick(event) {
    var button = event.currentTarget;
    var form = document.getElementById(button.getAttribute('data-form-id'));

    if (!form || button.disabled) {
      return;
    }

    if (isVariantUnavailable(form)) {
      return;
    }

    // Respect required fields inside the product form (e.g. custom properties).
    if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
      return;
    }

    clearError(form);
    setLoading(button, true);

    fetch(button.getAttribute('data-cart-add-url'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok) {
              throw new Error(data.description || data.message || DEFAULT_ERROR);
            }
            return data;
          });
      })
      .then(function () {
        window.location.href = button.getAttribute('data-redirect-url');
      })
      .catch(function (error) {
        showError(form, (error && error.message) || DEFAULT_ERROR);
        setLoading(button, false);
      });
  }

  // Hide the Buy Now button whenever the theme disables Add to Cart (sold out / unavailable variant).
  function syncAvailability(wrapper, form) {
    var addButton = form.querySelector('[data-add-to-cart]');
    if (!addButton) {
      return;
    }

    var update = function () {
      wrapper.classList.toggle('hidden', addButton.disabled);
    };

    update();
    new MutationObserver(update).observe(addButton, {
      attributes: true,
      attributeFilter: ['disabled']
    });
  }

  function init(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-poyter-buy-now]:not([' + READY_ATTR + '])');

    Array.prototype.forEach.call(buttons, function (button) {
      button.setAttribute(READY_ATTR, '');
      button.addEventListener('click', handleClick);

      var form = document.getElementById(button.getAttribute('data-form-id'));
      var wrapper = button.closest('[data-poyter-buy-now-wrapper]');
      if (form && wrapper) {
        syncAvailability(wrapper, form);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The theme's sticky cart bar has its own Add to Cart. When our button is active on the page,
  // route that click through the same flow so the customer also lands on the accessories page.
  document.addEventListener(
    'click',
    function (event) {
      var stickyButton = event.target.closest('[data-cart-bar-add-to-cart]');
      if (!stickyButton) {
        return;
      }

      var wrapper = document.querySelector('[data-poyter-buy-now-wrapper]:not(.hidden)');
      var button = wrapper && wrapper.querySelector('[data-poyter-buy-now]');
      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      button.click();
    },
    true
  );

  // Theme editor: re-initialise when a section is reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
